import { ALL_BUT_PRODUCTION, ALL_ENV, type EnvType } from 'core/infra/environment'

export type FeatureFlagType = {
  [key in featureFlag]?: {
    description: string
    env: EnvType[]
  }
}

export enum featureFlag {
  rfpAccessorials = 'rfp-accessorials',
  shipmentDetails = 'shipment-details',
  rfpBulkPreferredLanesAddExtraLanes = 'rfp-bulk-preferred-lanes-add-extra-lane',
  tenderPage = 'tenderPage',
  agnosticShipmentUploadPod = 'agnostic-shipment-upload-pod',
  agnosticShipmentManualLocationUpdates = 'agnostic-shipment-manual-location-updates',
  quoteAccessorials = 'quote-accessorials',
}

export const featureFlags: FeatureFlagType = {
  [featureFlag.rfpAccessorials]: {
    description: 'RFP accessorials tab',
    env: ALL_ENV,
  },
  [featureFlag.shipmentDetails]: {
    description: 'Agnostic Shipment Details page',
    env: ALL_ENV,
  },
  [featureFlag.rfpBulkPreferredLanesAddExtraLanes]: {
    description: 'RFP Bulk Preferred Lanes, Add Extra Lane flow',
    env: ALL_BUT_PRODUCTION,
  },
  [featureFlag.tenderPage]: {
    description: 'Tender page',
    env: ALL_ENV,
  },
  [featureFlag.agnosticShipmentUploadPod]: {
    description: 'POD upload for agnostic shipments',
    env: ALL_ENV,
  },
  [featureFlag.agnosticShipmentManualLocationUpdates]: {
    description: 'Manually add Driver locations in Agnostic Shipments',
    env: ALL_BUT_PRODUCTION,
  },
  [featureFlag.quoteAccessorials]: {
    description: 'Enables Accessorials on the quotes bidding page',
    env: ALL_BUT_PRODUCTION,
  },
}
